import {Injectable} from '@angular/core';
import {BaseService} from './_base.service';
import {Deal} from '../../models/deal.model';
import {Property} from '../../models/property.model';
import {HttpClient} from '@angular/common/http';
import { SuccessDto } from '../../dtos/success.dto';

@Injectable({
  providedIn: 'root'
})
export class DealsService extends BaseService {

  private endpoint = `deals`;

  constructor(protected http: HttpClient) {
    super(http);
  }

  createDeal(data: any) {
    return this.httpPost<Deal>(`${this.endpoint}`, data);
  }

  createPortfolio(data: any) {
    return this.httpPost<Deal>(`${this.endpoint}/portfolios`, data);
  }

  updateDeal(id: number, data: any) {
    return this.httpPut<SuccessDto>(`${this.endpoint}/${id}`, data);
  }

  addDealImage(id: number, file: File) {
    const formData = new FormData();
    formData.append('file', file, file.name);
    return this.http.post(
      `${this.apiUrl}${this.endpoint}/${id}/images`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem(this.TOKEN_NAME)}`
        }
      }
    );
  }

  deleteDealImage(id: number) {
    return this.httpDelete(`${this.endpoint}/images/${id}`);
  }

  addPropertyToDeal(dealId: number, data: any) {
    return this.httpPost<Property>(`${this.endpoint}/${dealId}/properties`, data);
  }

  updateProperty(id: number, data: any) {
    return this.httpPut<Property>(`${this.endpoint}/properties/${id}`, data);
  }

  updatePropertyImage(id: number, file: File, replaceId?: number) {
    const formData = new FormData();
    formData.append('file', file, file.name);
    return this.http.post(
      `${this.apiUrl}${this.endpoint}/properties/${id}/images/gallery${replaceId ? '?replaceId=' + replaceId : ''}`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem(this.TOKEN_NAME)}`
        }
      }
    );
  }

  deletePropertyImage(propertyId: number, imageId: number) {
    return this.httpDelete(`${this.endpoint}/properties/${propertyId}/images/gallery/${imageId}`);
  }

  validateProperty(id: number) {
    return this.httpPut(`${this.endpoint}/properties/${id}/validate`, {});
  }

  // HAYA Systems (REM - PBC - Gestor documental)- Deprecated - 30th July 2025
  // getDeals(): Observable<Deal[]> {
  //   return this.httpGet<Deal[]>(`${this.endpoint}`);
  // }
  //
  // getPortfolios(): Observable<Deal[]> {
  //   return this.httpGet<Deal[]>(`${this.endpoint}/portfolios`);
  // }
  //
  // getDealDetails(code: string) {
  //   return this.httpGet<Deal>(`${this.endpoint}/${code}`);
  // }
}
